import React, { FunctionComponent } from 'react';

import { InputType, StandardTextField } from '@components/library/text-field';
import { convertDaysToSeconds, convertSecondsToDays } from '@components/settings/brandfolder/advanced-tab/default-share-manifest-expiration/helpers';

interface ExpirationValueTextFieldProps {
  defaultExpirationValue: number | null;
  setDefaultExpirationValue: SetStateDispatch<number | null>;
}

const ExpirationValueTextField: FunctionComponent<ExpirationValueTextFieldProps>  = ({
  defaultExpirationValue,
  setDefaultExpirationValue
}) => {

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (['.', '-', '+', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;
    if (value !== '' && /^\d+$/.test(value)) {
      setDefaultExpirationValue(convertDaysToSeconds(value));
    }
  };

  return (
    <StandardTextField
      className='expiration-value-text-field'
      id="expiration-value-text-field"
      label='Days'
      max={90}
      min={1}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={'#'}
      step={1}
      type={InputType.Number}
      value={defaultExpirationValue ? convertSecondsToDays(defaultExpirationValue) : '1'}
    />
  );
};

export default ExpirationValueTextField;
